import { render, staticRenderFns } from "./sidebar-tag-group.vue?vue&type=template&id=9cea8f18&scoped=true&"
import script from "./sidebar-tag-group.vue?vue&type=script&lang=js&"
export * from "./sidebar-tag-group.vue?vue&type=script&lang=js&"
import style0 from "./sidebar-tag-group.vue?vue&type=style&index=0&id=9cea8f18&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cea8f18",
  null
  
)

export default component.exports